export const TRANSFER_FILE = "TRANSFER_FILE"
export const DEFROST_PROJECT = "DEFROST_PROJECT"
export const FREEZE_PROJECT = "FREEZE_PROJECT"
export const FREEZE_FILE = "FREEZE_FILE"
export const DEFROST_FILE = "DEFROST_FILE"
export const UPDATE_FILES_FILTER = "UPDATE_FILES_FILTER"